import { Icon, Size } from '@busybusy/webapp-react-ui';
import { PersonIcon } from 'assets/icons';
import classNames from 'classnames';
import './EmployeeCountIcon.scss';

export interface IEmployeeCountIconProps {
  memberCount: number;
  theme: 'dark' | 'light';
  className?: string | object;
}

function EmployeeCountIcon(props: IEmployeeCountIconProps) {
  const { memberCount, theme, className } = props;
  const classes = classNames('employee-count-icon', theme, className);

  return (
    <div className={classes}>
      <Icon svg={PersonIcon} size={Size.SMALL} />
      <div className="employee-count">{memberCount}</div>
    </div>
  );
}

export default EmployeeCountIcon;
